const fonts = `
  @font-face {
    font-family: Bebas Neue;
    font-weight: normal;
    font-display: swap;
    src: url('/fonts/BebasNeue-Regular.woff2') format('woff2');
    src: url('/fonts/BebasNeue-Regular.woff') format('woff');
  }
  @font-face {
    font-family: Open Sans;
    font-weight: 600;
    font-display: swap;
    src: url('/fonts/OpenSans-Semibold.woff2') format('woff2');
    src: url('/fonts/OpenSans-Semibold.woff') format('woff');
  }
  @font-face {
    font-family: Open Sans;
    font-weight: bold;
    font-display: swap;
    src: url('/fonts/OpenSans-Bold.woff2') format('woff2');
    src: url('/fonts/OpenSans-Bold.woff') format('woff');
  }
  @font-face {
    font-family: Open Sans;
    font-weight: normal;
    font-display: swap;
    font-style: italic;
    src: url('/fonts/OpenSans-Italic.woff2') format('woff2');
    src: url('/fonts/OpenSans-Italic.woff') format('woff');
  }
`;

export default fonts;
